import { gql } from 'apollo-angular';

export const goalCardSummaryItemFragment = gql`
  fragment GoalCardSummaryItem on GoalCardSummary {
    id
    title
    completedAt
    endDate
    severity
    startDate
    featured
    goalCardSummaryStatus
  }
`;
